// import React, { useState } from "react";
// import { ChevronDown, ChevronUp, X } from "lucide-react";
// import { Link } from "react-router-dom";
// import {
//   FaShoppingBag,
//   FaSearch,
//   FaHeart,
//   FaUser,
//   FaBars,
// } from "react-icons/fa";
// import logo from "../../../assets/images/logo/TYKA LOGO.png";

// const MobileNavbar = ({
//   menuOpen,
//   setMenuOpen,
//   menuData,
//   loadingMenu,
//   menuError,
//   cartCount = 0, // ✅ Props for cart count
// }) => {
//   const [openMenus, setOpenMenus] = useState({});
//   const [accountOpen, setAccountOpen] = useState(false); // ✅ Account Dropdown State

//   const toggleMenu = (id) => {
//     setOpenMenus((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   return (
//     <>
//       {/* ✅ Dimmed Background */}
//       {menuOpen && (
//         <div
//           className="fixed top-0 left-0 w-full h-full bg-black opacity-40 z-30"
//           onClick={() => setMenuOpen(false)}
//         ></div>
//       )}

//       {/* ✅ Sliding Mobile Navbar */}
//       <nav
//         className={`fixed top-0 left-0 w-[80%] bg-white h-screen overflow-y-auto z-50 transform transition-transform duration-300 shadow-md ${
//           menuOpen ? "translate-x-0" : "-translate-x-full"
//         }`}
//       >
//         {/* ✅ Header */}
//         <div className="flex items-center justify-between px-4 py-4 border-b border-gray-200 sticky top-0 bg-white z-50">
//           <img src={logo} alt="Logo" className="h-8" />
//           <button
//             onClick={() => setMenuOpen(false)}
//             className="text-gray-700 hover:text-red-600 p-2"
//             aria-label="Close"
//           >
//             <X size={26} />
//           </button>
//         </div>

//         {/* ✅ Menu Content */}
//         <div className="px-4 py-4 space-y-4">
//           {loadingMenu && <p className="text-gray-500">Loading menu...</p>}
//           {menuError && <p className="text-red-600">{menuError}</p>}

//           {menuData?.map((category) => (
//             <div key={category.id} className="border-b border-gray-100 pb-3">
//               {/* Main Category */}
//               <div
//                 className="font-semibold flex justify-between items-center cursor-pointer py-2"
//                 onClick={() => toggleMenu(category.id)}
//               >
//                 <span className="text-gray-900">{category.name}</span>
//                 {openMenus[category.id] ? (
//                   <ChevronUp size={18} className="text-gray-600" />
//                 ) : (
//                   <ChevronDown size={18} className="text-gray-600" />
//                 )}
//               </div>

//               {/* Subcategories */}
//               {openMenus[category.id] && category.subcategories?.length > 0 && (
//                 <div className="ml-3 mt-2 space-y-3">
//                   {category.subcategories.map((sub) => (
//                     <div key={sub.id}>
//                       <div
//                         className="font-medium flex justify-between items-center cursor-pointer text-gray-700"
//                         onClick={() => toggleMenu(sub.id)}
//                       >
//                         <span>{sub.name}</span>
//                         {openMenus[sub.id] ? (
//                           <ChevronUp size={16} className="text-gray-500" />
//                         ) : (
//                           <ChevronDown size={16} className="text-gray-500" />
//                         )}
//                       </div>

//                       {/* Children */}
//                       {openMenus[sub.id] && sub.children?.length > 0 && (
//                         <ul className="ml-4 mt-2 space-y-2 text-sm">
//                           {sub.children.map((child) => (
//                             <li key={child.id}>
//                               <Link
//                                 to={`/post/${child.slug}`}
//                                 onClick={() => setMenuOpen(false)}
//                                 className="block hover:text-red-600"
//                               >
//                                 {/* <Link
//                                 to={`/${category.slug}/${sub.slug}/${child.slug}`}
//                                 onClick={() => setMenuOpen(false)}
//                                 className="block hover:text-red-600"
//                               > */}
//                                 {child.name}
//                               </Link>
//                             </li>
//                           ))}
//                         </ul>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           ))}

//           {/* Extra Static Link */}
//           <div className="pt-4">
//             <Link
//               to="/design-your-own"
//               onClick={() => setMenuOpen(false)}
//               className="block text-gray-900 font-semibold hover:text-red-600"
//             >
//               DESIGN YOUR OWN
//             </Link>
//           </div>

//           <hr className="my-4 border-gray-300" />
//           <p className="text-sm font-semibold text-gray-700">Categories</p>

//           {/* Footer */}
//           <div className="mt-12 text-center text-sm text-gray-800 pb-6">
//             Copyright 2025 © Tyka Sports. All rights reserved
//           </div>
//         </div>
//       </nav>

//       {/* ✅ Bottom Mobile Icons */}
//       <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 flex justify-around py-2 z-50">
//         {/* 🛒 Cart Icon with Badge */}
//         <div className="relative flex flex-col items-center text-xs text-gray-700">
//           <Link to="/cart" className="flex flex-col items-center">
//             <FaShoppingBag className="text-lg" />
//             {cartCount > 0 && (
//               <span className="absolute -top-1 -right-2 bg-red-600 text-white text-[10px] font-bold rounded-full px-1">
//                 {cartCount}
//               </span>
//             )}
//             <span>Cart</span>
//           </Link>
//         </div>

//         {/* 🔍 Search */}
//         <div className="flex flex-col items-center text-xs text-gray-700">
//           <FaSearch className="text-lg" />
//           <span>Search</span>
//         </div>

//         {/* ❤️ Wishlist */}
//         <div className="flex flex-col items-center text-xs text-gray-700">
//           <FaHeart className="text-lg" />
//           <span>Wishlist</span>
//         </div>

//         {/* 👤 Account with Dropdown */}
//         <div className="relative flex flex-col items-center text-xs text-gray-700">
//           <div
//             className="cursor-pointer flex flex-col items-center"
//             onClick={() => setAccountOpen(!accountOpen)}
//           >
//             <FaUser className="text-lg" />
//             <span>Account</span>
//           </div>

//           {accountOpen && (
//             <div className="absolute bottom-12 right-0 w-28 bg-white border rounded-lg shadow-md z-50">
//               <Link
//                 to="/login"
//                 className="block px-3 py-2 text-sm hover:bg-gray-100"
//                 onClick={() => setAccountOpen(false)}
//               >
//                 Login
//               </Link>
//               <Link
//                 to="/signup"
//                 className="block px-3 py-2 text-sm hover:bg-gray-100"
//                 onClick={() => setAccountOpen(false)}
//               >
//                 Sign Up
//               </Link>
//             </div>
//           )}
//         </div>

//         {/* 📂 Categories Button */}
//         <div
//           className="flex flex-col items-center text-xs text-gray-700 cursor-pointer"
//           onClick={() => setMenuOpen(true)}
//         >
//           <FaBars className="text-lg" />
//           <span>Categories</span>
//         </div>
//       </div>
//     </>
//   );
// };

// export default MobileNavbar;

import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, ChevronUp, X } from "lucide-react";
import { Link } from "react-router-dom";
import {
  FaShoppingBag,
  FaSearch,
  FaHeart,
  FaUser,
  FaBars,
} from "react-icons/fa";
import logo from "../../../assets/images/logo/TYKA LOGO.png";
import CartDrawer from "../cartpage/CartDrawer";
import WishlistDrawer from "../../common/cartpage/WishlistDrawer";
import SearchModal from "./SearchModal";

const MobileNavbar = ({
  menuOpen,
  setMenuOpen,
  menuData,
  loadingMenu,
  menuError,
  cartCount = 0,
  wishlistCount = 0,
  wishlistOpen,
  setWishlistOpen,
  searchOpen,
  setSearchOpen,
  cartOpen,
  setCartOpen,
  token,
  userName,
  logout,
}) => {
  const [openMenus, setOpenMenus] = useState({});
  const [accountOpen, setAccountOpen] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const hideTimeoutRef = useRef(null);
  const menuHideTimeoutRef = useRef(null);

  const toggleMenu = (id) => {
    setOpenMenus((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  // Click outside handler
  const handleMouseEnter = () => {
    clearTimeout(hideTimeoutRef.current);
    setShowUserDropdown(true);
  };

  const handleMouseLeave = () => {
    hideTimeoutRef.current = setTimeout(() => {
      setShowUserDropdown(false);
    }, 500);
  };
  return (
    <>
      {/* ✅ Dimmed Background */}
      {menuOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black opacity-40 z-30"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}

      {/* ✅ Sliding Mobile Navbar */}
      <nav
        className={`fixed top-0 left-0 w-[80%] bg-white h-screen overflow-y-auto z-50 transform transition-transform duration-300 shadow-md ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* ✅ Header */}
        <div className="flex items-center justify-between px-4 py-4 border-b border-gray-200 sticky top-0 bg-white z-50">
          <img src={logo} alt="Logo" className="h-8" />
          <button
            onClick={() => setMenuOpen(false)}
            className="text-gray-700 hover:text-red-600 p-2"
            aria-label="Close"
          >
            <X size={26} />
          </button>
        </div>

        {/* ✅ Menu Content */}
        <div className="px-4 py-4 space-y-4">
          {loadingMenu && <p className="text-gray-500">Loading menu...</p>}
          {menuError && <p className="text-red-600">{menuError}</p>}

          {menuData?.map((category) => (
            <div key={category.id} className="border-b border-gray-100 pb-3">
              <div
                className="font-semibold flex justify-between items-center cursor-pointer py-2"
                onClick={() => toggleMenu(category.id)}
              >
                <span className="text-gray-900">{category.name}</span>
                {openMenus[category.id] ? (
                  <ChevronUp size={18} className="text-gray-600" />
                ) : (
                  <ChevronDown size={18} className="text-gray-600" />
                )}
              </div>

              {openMenus[category.id] && category.subcategories?.length > 0 && (
                <div className="ml-3 mt-2 space-y-3">
                  {category.subcategories.map((sub) => (
                    <div key={sub.id}>
                      <div
                        className="font-medium flex justify-between items-center cursor-pointer text-gray-700"
                        onClick={() => toggleMenu(sub.id)}
                      >
                        <span>{sub.name}</span>
                        {openMenus[sub.id] ? (
                          <ChevronUp size={16} className="text-gray-500" />
                        ) : (
                          <ChevronDown size={16} className="text-gray-500" />
                        )}
                      </div>

                      {openMenus[sub.id] && sub.children?.length > 0 && (
                        <ul className="ml-4 mt-2 space-y-2 text-sm">
                          {sub.children.map((child) => (
                            <li key={child.id}>
                              <Link
                                to={`/post/${child.slug}`}
                                onClick={() => setMenuOpen(false)}
                                className="block hover:text-red-600"
                              >
                                {child.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          <div className="pt-4">
            <Link
              to="/newarrival"
              onClick={() => setMenuOpen(false)}
              className="block text-gray-900 font-semibold hover:text-red-600"
            >
              NEW ARRIVALS
            </Link>
          </div>

          <div className="pt-4">
            <Link
              to="/design-your-own"
              onClick={() => setMenuOpen(false)}
              className="block text-gray-900 font-semibold hover:text-red-600"
            >
              DESIGN YOUR OWN
            </Link>
          </div>

          <hr className="my-4 border-gray-300" />
          {/* <p className="text-sm font-semibold text-gray-700">Categories</p> */}

          <div className="mt-12 text-center text-sm text-gray-800 pb-6">
            Copyright 2025 © Tyka Sports. All rights reserved
          </div>
        </div>
      </nav>

      {/* ✅ Bottom Mobile Icons */}
      {/* <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 flex justify-around py-2 z-50"> */}
      <div className="lg:hidden fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 flex justify-around py-2 z-50">
        {/* 🛒 Cart */}
        <div
          className="relative flex flex-col items-center text-xs text-gray-700 cursor-pointer"
          onClick={() => setCartOpen(true)}
        >
          <FaShoppingBag className="text-lg" />
          {cartCount > 0 && (
            <span className="absolute -top-1 -right-2 bg-red-600 text-white text-[10px] font-bold rounded-full px-1">
              {cartCount}
            </span>
          )}
          <span>Cart</span>
        </div>
        {/* 🔍 Search */}
        <div
          className="flex flex-col items-center text-xs text-gray-700 cursor-pointer"
          onClick={() => setSearchOpen(true)}
        >
          <FaSearch className="text-lg" />
          <span>Search</span>
        </div>
        <SearchModal isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
        {/* ❤️ Wishlist */}
        {token && (
          <div
            className="flex flex-col items-center text-xs text-gray-700 cursor-pointer relative"
            onClick={() => setWishlistOpen(true)}
          >
            <FaHeart className="text-lg" />
            {wishlistCount > 0 && (
              <span className="absolute -top-1 -right-0 bg-red-600 text-white text-[10px] font-bold rounded-full px-1">
                {wishlistCount}
              </span>
            )}
            <span>Wishlist</span>
          </div>
        )}
        <WishlistDrawer
          isOpen={wishlistOpen}
          onClose={() => setWishlistOpen(false)}
        />
        {/* 👤 Account */}
        {/* 👤 Account */}
        <div className="relative flex flex-col items-center text-xs text-gray-700">
          <div
            className="cursor-pointer flex flex-col items-center"
            onClick={() => setAccountOpen(!accountOpen)}
          >
            <FaUser className="text-lg" />
            <span>{token ? userName : "Account"}</span>
          </div>

          {accountOpen && (
            <div className="absolute bottom-12 right-0 w-40 bg-white border rounded-lg shadow-md z-50">
              {token ? (
                <>
                  <Link
                    to={`/userdashboard/${userName}`}
                    onClick={() => setAccountOpen(false)}
                    className="block px-3 py-2 text-sm hover:bg-gray-100"
                  >
                    Dashboard
                  </Link>
                  <Link
                    to={`/userorder/${userName}`}
                    onClick={() => setAccountOpen(false)}
                    className="block px-3 py-2 text-sm hover:bg-gray-100"
                  >
                    Orders
                  </Link>
                  <Link
                    to={`/userprofile/${userName}`}
                    onClick={() => setAccountOpen(false)}
                    className="block px-3 py-2 text-sm hover:bg-gray-100"
                  >
                    Profile
                  </Link>
                  <button
                    onClick={() => {
                      logout();
                      setAccountOpen(false);
                    }}
                    className="block px-3 py-2 text-sm hover:bg-gray-100 w-full text-left text-red-500"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="block px-3 py-2 text-sm hover:bg-gray-100"
                    onClick={() => setAccountOpen(false)}
                  >
                    Login
                  </Link>
                  <Link
                    to="/signup"
                    className="block px-3 py-2 text-sm hover:bg-gray-100"
                    onClick={() => setAccountOpen(false)}
                  >
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          )}
        </div>
        {/* 📂 Categories */}
        <div
          className="flex flex-col items-center text-xs text-gray-700 cursor-pointer"
          onClick={() => setMenuOpen(true)}
        >
          <FaBars className="text-lg" />
          <span>Categories</span>
        </div>
      </div>

      {/* ✅ Cart Drawer */}
      <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} />
    </>
  );
};

export default MobileNavbar;
